import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from 'apollo-react/components/Modal';
import { Formik, Form, Field } from "formik";
import Grid from "apollo-react/components/Grid";
import SwitchInput from "../../common/Form/switchInput";
import { renderInputComponent } from "../../common/Form/renderInputComponent";
import Button from "../../common/Button";

const DynamicForm = ({ persona }) => {
  const [formFields, setFormFields] = useState([]);
  const [formData, setFormData] = useState({status: true});
  const [formDataCopy, setFormDataCopy] = useState({status: true});
  const [isUpdate, setIsUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [resp, setResp] = useState("");
  const [token, setToken] = useState("");
  const [t] = useTranslation();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({});
  const [discardModal, setDiscardModal] = useState(false);
  
  const navigate = useNavigate();

  // Fetch form fields and data (if updating) from the backend
  useEffect(() => {
    const fetchFormMetadata = async () => {
      try {
        const formFields = [
          { name: "name", type: "text", label: "Category Name", required: true },
          { name: "description", type: "text", label: "Description", required: false },
        ];
        setFormFields(formFields);
        if (id) {
          // If we have an ID, fetch data for updating
          setIsUpdate(true);
          const { data: recordData } = await axiosInstance.get(`/api/categories/${id}`, {
            headers: {
              authorization: token,
            },
          });

          setFormData({...recordData, status: recordData.status === "published_active"});
          setFormDataCopy({...recordData, status: recordData.status === "published_active"});
        }
        // const { data: fieldDefinitions } = await axiosInstance.get('/api/form-fields');
        // setFormFields(fieldDefinitions);

        setLoading(false);
      } catch (err) {
        setResp(t("Error fetching form metadata or data"));
        setLoading(false);
      }
    };

    fetchFormMetadata();
  }, [id, t]);

  useEffect(() => {
    const initialValues = formFields.reduce((acc, field) => {
      acc[field.name] = formData[field.name] || "";
      return acc;
    }, {});

    setInitialValues(initialValues);
  }, [formFields, formData]);

  // Handle input changes
  const handleChange = (name, value) => {
    
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

  // Handle form submission (Add or Update)
  const handleSubmit = async (e) => {
    const updatedFormData = {...formData, status: formData["status"] ? "published_active" : "not_published"};
    try {
      if (isUpdate) {
        console.log('fata:',formData);
        
        axiosInstance
          .put(`/api/categories/${id}`, updatedFormData, {
            withCredentials: true,
          }
          )
          .then((resp) => {
            toast.success("Category Updated Successfully!", {
              position: "top-center",
            });

            navigate(-1);
          })
          .catch((error) => {
            setResp(t("Error updating form"), ":", error);
          });
      } else {
        axiosInstance
          .post("/api/categories/create", updatedFormData)
          .then((resp) => {
            toast.success(t("Category Added Successfully!"), {
              position: "top-center",
            });
            setToken("");
            if (resp.data.token) {
              setToken(resp.data.token);
            } else {
              navigate(-1);
            }
          })
          .catch((error) => {
            setResp(t("Error creating form"), ":", error);
          });
      }
    } catch (err) {
      setResp(t("Error submitting form"), ":", err);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div
    className="content"
    style={{
      border: "solid 1px #E9E9E9",
      padding: "24px",
      borderRadius: "5px",
    }}
    >
			{/* {resp && <p>{resp}</p>} */}
			<Grid item md={12}>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={handleSubmit}
					>
						{({ handleSubmit, setFieldValue }) => (
							<Form onSubmit={handleSubmit}>
								{formFields.map((field) => (
									<Field key={field.name} name={field.name}>
										{({ field: formikField, meta }) => {
											const handleFieldChange = (value) => {
												console.log("formikField", formikField, value);
												setFieldValue(formikField.name, value);
												handleChange(formikField.name, value);
											};

                      let updatedFormikField = formikField;
                      if(field.name === "description")
                        updatedFormikField = {...updatedFormikField, multiline: true, textareaWidth: "100%"}

											return renderInputComponent(
												field,
												formData,
												updatedFormikField,
												meta,
												handleFieldChange
											);
										}}
									</Field>
								))}
								{!isUpdate ? (
									<Field name={"status"}>
										{({ field: formikField, meta }) => (
											<SwitchInput
												{...formikField}
												meta={meta}
												name={"status"}
												onChange={(checked) =>
													handleChange(
														"status",
														checked 
													)
												}
												label={t("publish")}
												value={formData["status"]}
												style={{ marginTop: "16px", marginBottom: "8px" }}
											/>
										)}
									</Field>
								) : null}
                <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '50px'}}>
                <Button
								color="primary"
          			onClick={() => setDiscardModal(true)}
								style={{
									padding: "12px 22px",
									width: "157px",
            			height: '40px',
            			marginRight: '24px',
								}}
          			text={t("Discard")}
						    />

                <Button
							  color="primary"
							  type="submit"
							  style={{
								padding: "12px 22px",
								width: "157px",
                height: '40px',
							  }}
                text={t("Save")}
						    />
              </div>
							</Form>
						)}
					</Formik>
					{token && (
						<div className="mt-2 p-2 card">
							<h6>Generated Token:</h6>
							<p className="">{token}</p>
						</div>
					)}
			</Grid>
                        <Modal
                        open={discardModal}
                        message="Are you sure you want to discard your changes?"
                        buttonProps={[{onClick: () => {
                          setDiscardModal(false);
                          }},
                          { label: 'Confirm', onClick: () => {
                            setDiscardModal(false);
                            setFormData(formDataCopy);
                          } }]}
                        hideHeader
                        id="hideHeader"
                      />
		</div>
	);
};

export default DynamicForm;
